import React from 'react';
import { EventTypeProvider } from '../contexts/EventTypeContext';
import { CalendarOptionsMapper } from '../../../mappers/CalendarOptionsMapper';

/**
 * @typedef {object} EventTypeDataProviderProps
 * @property {React.ReactNode} children
 * @property {Array<*>} [sowContractTypes]
 * @property {Array<*>} [atmRoleOptions]
 */

/**
 * @param {EventTypeDataProviderProps} props
 */
const EventTypeDataProvider = props => {
  const { children, sowContractTypes, atmRoleOptions } = props;

  const config = {
    atmRoleOptions: CalendarOptionsMapper.mapAtmRolesForEvent(atmRoleOptions),
    contractTypeOptions: CalendarOptionsMapper.mapSowContractTypesForEvent(sowContractTypes)
  };

  return <EventTypeProvider value={config}>{children}</EventTypeProvider>;
};

export default EventTypeDataProvider;
